import React from "react"
import contact from "../../assets/images/contact.png"
import { useState } from "react"

const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  })
  const [status, setStatus] = useState("")
  const [isSending, setIsSending] = useState(false)

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setStatus("Sending...")
    setIsSending(true)

    const trimmed = {
      name: form.name.trim(),
      email: form.email.trim(),
      phone: form.phone.trim(),
      message: form.message.trim(),
    }

    if (!trimmed.name || !trimmed.email || !trimmed.phone || !trimmed.message) {
      setStatus("Please fill all fields.")
      setIsSending(false)
      return
    }

    if (!/^[1-9][0-9]{9}$/.test(trimmed.phone)) {
      setStatus("Phone number must be 10 digits and should not start with 0.")
      setIsSending(false)
      return
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed.email)) {
      setStatus("Please enter a valid email address.")
      setIsSending(false)
      return
    }

    try {
    // Prefer explicitly configured contact API base, fall back to Strapi URL
    const envBase = (process.env.GATSBY_STRAPI_URL || "").replace(/\/+$/, "")
    const contactBase = (process.env.GATSBY_CONTACT_API_URL || "").replace(/\/+$/, "")
      const hostname =
        typeof window !== "undefined" && window.location
          ? window.location.hostname
          : ""
      const isLocal = hostname === "localhost" || hostname === "127.0.0.1"
      const localBase = contactBase || envBase || "http://localhost:1337"
      // In production prefer absolute API URLs so Gatsby static host doesn't swallow the route
      const remoteBases = [contactBase || envBase, envBase].filter(Boolean)
      const endpoints = isLocal
        ? [`${localBase}/contact`]
        : [...remoteBases.map(base => `${base}/contact`), "/api/contact", "/contact"]

      let data = null
      let lastError = null

      for (const endpoint of endpoints) {
        try {
          const res = await fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(trimmed),
          })

          const contentType = res.headers.get("content-type") || ""
          const rawBody = await res.text()
          const parsedBody = rawBody ? (() => {
            try {
              return JSON.parse(rawBody)
            } catch {
              return null
            }
          })() : null

          data = contentType.includes("application/json")
            ? parsedBody || {}
            : parsedBody || {}

          if (res.ok && data.success !== false) {
            setStatus("Message sent successfully ✅")
            setForm({ name: "", email: "", phone: "", message: "" })
            return
          }

          lastError =
            data?.error || data?.message || `Request failed (${res.status})`
        } catch (innerErr) {
          lastError = innerErr.message
        }
      }

      setStatus(`Failed to send ❌ ${lastError ? `(${lastError})` : ""}`)
    } catch (err) {
      setStatus("Error: " + err.message)
    } finally {
      setIsSending(false)
    }
  }

  return (
    <section className="contact-area pb-100">
      <div className="container">
        <div className="section-title">
          {/* <span className="sub-title">
                        <img src={starIcon} alt="contact" /> 
                        Get in Touch
                    </span> */}
          <h2>Ready to Get Started?</h2>
          {/* <p>Your email address will not be published. Required fields are marked *</p> */}
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="contact-image">
              <img src={contact} alt="contact" />
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="contact-form">
              <form id="contactForm" onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-lg-12 col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        required
                        placeholder="Your name*"
                        value={form.name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        required
                        placeholder="Your email address*"
                        value={form.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        required
                        pattern="[1-9]{1}[0-9]{9}"
                        maxLength="10"
                        size="10"
                        placeholder="Your phone number*"
                        value={form.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        className="form-control"
                        cols="30"
                        rows="6"
                        required
                        placeholder="Write your message..."
                        value={form.message}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 col-md-12">
                    <button
                      type="submit"
                      className="default-btn"
                      disabled={isSending}
                    >
                      {isSending ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                  {status && (
                    <div className="col-lg-12 col-md-12 mt-3">
                      <p
                        style={{ margin: 0, color: "#221638", fontWeight: 500 }}
                      >
                        {status}
                      </p>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactForm
